<div class="chip-group-field">
  <label class="chip-group-label" [id]="id + '-label'">
    {{ label }}
    <span *ngIf="required"> *</span>
  </label>
  <div
    class="chip-group"
    [class.chip-group-invalid]="isInvalid"
    role="group"
    [id]="id"
    [attr.aria-labelledby]="id + '-label'"
    [attr.aria-required]="required ? 'true' : null"
    [attr.aria-invalid]="isInvalid"
    [attr.aria-describedby]="isInvalid ? errorId : null"
  >
    <button
      type="button"
      class="chip"
      *ngFor="let option of options"
      [attr.aria-pressed]="isSelected(option.value)"
      [class.chip-selected]="isSelected(option.value)"
      [class.chip-unselected]="!isSelected(option.value)"
      (click)="toggleOption(option.value)"
    >
      {{ option.label }}
    </button>
  </div>
  <p [id]="errorId" class="chip-group-error" *ngIf="isInvalid">
    {{ errorText }}
  </p>
</div>
